<template>
  <div class="tournament-info-wrapper col-12">
    <div class="d-flex justify-content-between">
      <Title
        class="mb-5"
        :text="$$t('Tournament Settings', 'tournament-settings-page-title')"
      />
    </div>

    <SectionGameAndPlatform />
    <SectionAppearance id="settings-appearance" class="mt-6" />
    <SectionPaid v-if="isPaidTournamentAllowed" class="mt-6" />
    <SectionSchedule id="settings-schedule" class="mt-6" />
    <SectionParticipantsSettings id="settings-participants" class="mt-6" />
    <SectionPrizes class="mt-6" />
    <SectionRegistrationForm class="mt-6" />
    <SectionRules class="mt-6" />
    <SectionLicense class="mt-6" />

    <SectionAdmin class="mt-6" />
    <SectionPromotion
      id="settings-promotion"
      class="mt-6"
      style="margin-bottom: 150px"
    />
    <!-- <SectionEventOperations class="mt-6" /> -->
    <!-- <SectionAdditionalSettings class="my-6" /> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { translate } from '@/mixins/translate';
import SectionGameAndPlatform from '@/views/tournaments/management/singleTournament/components/SectionGameAndPlatform';
import SectionAppearance from '@/views/tournaments/management/singleTournament/components/SectionAppearance';
import SectionPromotion from '@/views/tournaments/management/singleTournament/components/SectionPromotion';
import SectionSchedule from '@/views/tournaments/management/singleTournament/components/SectionSchedule';
import SectionLicense from './components/SectionLicense.vue';

// import SectionEventOperations from '@/views/tournaments/management/singleTournament/components/SectionEventOperations';
// import SectionAdditionalSettings from '@/views/tournaments/management/singleTournament/components/SectionAdditionalSettings';
import SectionPaid from '@/views/tournaments/management/singleTournament/components/SectionPaid';
import SectionAdmin from './components/SectionAdmin.vue';
import SectionParticipantsSettings from '@/views/tournaments/management/singleTournament/components/SectionParticipantSettings';
import SectionPrizes from '@/views/tournaments/management/singleTournament/components/SectionPrizes';
import SectionRules from '@/views/tournaments/management/singleTournament/components/SectionRules';
import SectionRegistrationForm from '@/views/tournaments/management/singleTournament/components/SectionRegistrationForm';
import Title from '@/components/atoms/Title';
// import StatusBtn from '@/views/tournaments/management/singleTournament/components/StatusBtn';

export default {
  name: 'TournamentInfo',
  inject: ['$validator'],
  components: {
    Title,
    SectionRules,
    SectionPrizes,
    SectionLicense,
    // SectionAdditionalSettings,
    SectionGameAndPlatform,
    SectionAppearance,
    SectionPaid,
    SectionPromotion,
    SectionSchedule,
    SectionRegistrationForm,
    SectionParticipantsSettings,
    SectionAdmin,
    // SectionEventOperations,
    // StatusBtn,
  },
  mixins: [translate('_web_tournament_settings')],
  props: {
    titleTranslationKey: {
      type: String,
      default: '_web_tournament_game_default-title',
    },
  },
  data() {
    return {
      isPaidTournamentAllowed: false,
    };
  },
  computed: {
    ...mapGetters(['currentTournament']),
  },

  created() {
    this.premmisionCheck();
  },
  mounted() {
    if (this.$route.hash) {
      const tab = this.$route.hash.substring(1);
      const element = document.getElementById(tab);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  },
  methods: {
    premmisionCheck() {
      const accessTokenString = localStorage.getItem('accessToken');

      if (accessTokenString) {
        try {
          const accessTokenObject = JSON.parse(accessTokenString);

          const token = accessTokenObject.token;
          const payload = token.split('.')[1];
          const decodedPayload = atob(payload);
          const permissions = JSON.parse(decodedPayload).permissions;
          const arrayOfTournamentRoot = permissions.filter(
            item => item.Root === 'tournament'
          );
          if (arrayOfTournamentRoot) {
            const arrayOfPaidTournament = arrayOfTournamentRoot.filter(
              item => item.Action === 'paid_tournament'
            );
            return (this.isPaidTournamentAllowed =
              arrayOfPaidTournament.length > 0 ? true : false);
          }
        } catch (error) {
          console.error('Error decoding Base64:', error);
        }
      } else {
        console.error('Access token not found in local storage.');
      }
    },
  },
};
</script>
